import reduxReducerHelper, { mapDefaultValuesToActions } from '../../utils/reduxReducerHelperUtil';

import { appSubscriptionsStoreStates } from '../../hooks/useAppSubscriptionsHook';

const mappingsActions = mapDefaultValuesToActions(appSubscriptionsStoreStates);

export default reduxReducerHelper(mappingsActions, appSubscriptionsStoreStates);
